import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

import styles from './SbRespProminentTileDescription.scss';

function SbRespProminentTileDescriptionComponent({ item }) {
    const quickViewParagraphs = get(item, 'quickViewDisplay.paragraphs');
    const quickViewDescription = quickViewParagraphs.find(({ key }) => key === 'description');

    return quickViewDescription ? (
        <div className={styles.description}>{quickViewDescription.text}</div>
    ) : null;
}

SbRespProminentTileDescriptionComponent.propTypes = {
    item: PropTypes.object.isRequired,
};

export const SbRespProminentTileDescription = createFragmentContainer(
    SbRespProminentTileDescriptionComponent,
    {
        item: graphql`
            fragment SbRespProminentTileDescription_item on Item {
                quickViewDisplay {
                    paragraphs {
                        key
                        text
                    }
                }
            }
        `,
    }
);
